import { useStaticData } from '@mc/static-data-react'
import { Heading } from '../Heading'
import { WhatBringsYouVariantPALM } from '../WhatBringsYouVariantPALM'
import { QuizOnlyOnceHeading } from './QuizOnlyOnceHeading'

export const QuizOnlyOnce = () => {
  const { ctaNextPage } = useStaticData<{ ctaNextPage?: string }>()

  const isQuizCompleted = !!ctaNextPage

  if (!isQuizCompleted) return <HeroQuizComponents />

  return <QuizOnlyOnceHeading />
}

const HeroQuizComponents = () => (
  <>
    <Heading />
    <WhatBringsYouVariantPALM />
  </>
)
